<template lang="html">
  <div>
    <terminal-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      >
        <template
          slot="appMode"
          slot-scope="props"
        >
          <div>{{ appModeTypeMap[props.item.appMode].textShort }}</div>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import TerminalItem from './TerminalItem'

export default {
  name: 'TerminalList',
  components: {TerminalItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Terminal',
      types: 'Terminals',
      headers: [
        this.headerText('Terminal', 'name', true),
        this.headerText('Group', 'groupName', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'terminal',
      terminalGroups: []
    }
  },
  computed: {
    appModeTypeMap () {
      return this.appModes.reduce((acc, b) => {
        acc[b.value] = b
        return acc
      }, {})
    }
  },
  methods: {
    listResourceCommands () {
      return [
        {
          command: 'terminalGroup',
          load: this.terminalGroups,
          loading: this.isLoading,
          // params: {filter_methods: {filterFieldValue: ['appMode', this.$ftAPI().appMode()]}}
        }
      ]
    },
    listCommandFilter (command) {
      return this.addCommandParam(command, 'filter_methods', {filterFieldValue: ['appMode', this.$ftAPI().appMode()]})
    }
  }
}
</script>
